import { createAsyncThunk } from '@reduxjs/toolkit';

import { NewsService } from 'api';

import { MarkNewsItemProps } from 'models';

export const markAsRead = createAsyncThunk('news/markAsRead', async (params: MarkNewsItemProps) => {
	return await NewsService.markAsRead(params);
});
